export default "__VITE_ASSET__DCTafBg6__"